import { envTypeGet } from "../common";
import { API_TYPES } from "./api_constants";

export type UrlBases = {
  auth: string;
  sakusas: string;
};

export type ApiType = "auth" | "sakusas";

export const apiUrlBasesGet = (): UrlBases => {
  const envType = envTypeGet();
  let urlBases = {
    sakusas: "http://localhost:3011/api/v1",
    auth: "http://localhost:3012/api/v1",
  };
  if (envType === "production") {
    urlBases = {
      sakusas: "https://sakusas.emlearn.info/api/sakusas/v1",
      auth: "https://sakusas.emlearn.info/api/auth-sakusas/v1",
    };
  }

  return urlBases;
};

export const apiTypeUrlBaseGet = (apiType: string): string => {
  const urlBases: UrlBases = apiUrlBasesGet();
  const url = urlBases[apiType as ApiType];
  return url;
};

export const apiTypeUrlGet = (apiType: string, path: string): string => {
  const urlBase: string = apiTypeUrlBaseGet(apiType);
  const url = urlBase + "/" + path;
  return url;
};

export const apiAuthUrlGet = (path: string = ""): string => {
  const url: string = apiTypeUrlGet(API_TYPES.AUTH, path);
  return url;
};

export const apiSakusasUrlGet = (path: string = ""): string => {
  const url: string = apiTypeUrlGet(API_TYPES.SAKUSAS, path);
  return url;
};
